var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppMediaPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.999,2.09229303 C11.2007589,2.17281409 11.3331669,2.36805984 11.3333333,2.58529303 L11.3333333,8.72087636 C11.3331669,8.93810955 11.2007589,9.1333553 10.999,9.21387636 L5.86358333,11.268043 C5.73694541,11.3186891 5.59567959,11.3186891 5.46904167,11.268043 L0.333625,9.21387636 C0.132144352,9.13313067 0,8.93793469 0,8.72087636 L0,2.58529303 C0,2.36823471 0.132144352,2.17303872 0.333625,2.09229303 L5.272125,0.116751362 L5.27495833,0.116043029 L5.46904167,0.0381263625 C5.59588804,-0.0127087875 5.7374453,-0.0127087875 5.86429167,0.0381263625 L6.058375,0.116043029 L6.06120833,0.116751362 L10.999,2.09229303 Z M10.02575,2.4655847 L5.66666667,4.20950136 L1.30758333,2.4655847 L0.708333333,2.7057097 L0.708333333,2.98904303 L5.3125,4.8307097 L5.3125,10.4421264 L5.66666667,10.583793 L6.02083333,10.4421264 L6.02083333,4.83141803 L10.625,2.98975136 L10.625,2.70641803 L10.02575,2.46629303 L10.02575,2.4655847 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI---Signup-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "poratal/landing/sign-up",
    transform: "translate(-856.000000, -786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(856.000000, 786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element/icon/box-fill",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-base",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "variables/colors/black",
    transform: "translate(2.833333, 2.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#ADB5BD",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.666667, -2.833333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 56.6666667,
    height: 56.6666667
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M21.0787088,3 L21.252674,3.44142108 L12.427864,7.02411094 L17.4183654,9.04989707 L17.4183654,5.36012326 L17.8867811,5.36012326 L17.8867811,9.24006709 L20.5637764,10.3269649 L20.4254172,10.7828285 L17.8867811,9.75209987 L17.8867811,15.8009328 L21.2247327,14.4458833 L21.3451879,14.9090218 L17.8867811,16.3129656 L17.8867811,20.3650133 L20.7842582,21.5415769 L20.610293,21.982998 L17.8867811,20.877046 L17.8867811,22 L17.4183654,22 L17.4183654,20.686876 L12.2657921,18.5950058 L6.64480312,20.877046 L6.64480312,21.524575 L6.17638737,21.524575 L6.17638737,21.0672161 L3.92129124,21.982998 L3.747326,21.5415769 L6.17638737,20.5551833 L6.17638737,16.123271 L2.81607889,14.7589181 L2.98513799,14.315275 L6.17638737,15.6107628 L6.17638737,9.56192985 L2.8742675,10.9026778 L2.72233223,10.4523221 L6.17638737,9.04989707 L6.17638737,4.99784937 L4.6841575,4.39227118 L4.85812274,3.9508501 L11.7973764,6.76785683 L21.0787088,3 Z M6.64480312,16.313441 L6.64480312,20.3650133 L11.6348361,18.3392271 L6.64480312,16.313441 Z M17.4183654,16.5031356 L12.8962797,18.3392271 L17.4183654,20.1748432 L17.4183654,16.5031356 Z M11.7973764,7.27988961 L6.64480312,9.37175983 L6.64480312,15.8009328 L12.2657921,18.082973 L17.4183654,15.9911028 L17.4183654,9.56192985 L11.7973764,7.27988961 Z M6.64480312,5.18849482 L6.64480312,8.85972705 L11.1664204,7.02411094 L6.64480312,5.18849482 Z",
    id: "Combined-Shape",
    fill: "#979797",
    fillRule: "nonzero",
    opacity: 0.245557513
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMediaPlaceholder);
export default __webpack_public_path__ + "static/media/app-media-placeholder.09ea912b0a5ae54b6011528c736e0c55.svg";
export { ForwardRef as ReactComponent };